import React from "react";
import { connect } from "react-redux";
import { PrivateRoute } from "./PrivateRoute";

export const Index = ({ organization, children, superUser, userFetched, ...rest }) => {
  return (
    <PrivateRoute
      organization={organization}
      superUser={superUser}
      userFetched={userFetched}
      {...rest}>
      {children}
    </PrivateRoute>
  );
};

const mapStateToProps = (state) => {
  return {
    organization: state.user?.organization,
    superUser: state.user?.superUser,
    userFetched: state.user?.fetched
  };
};

export default connect(mapStateToProps, {})(Index);
